import type { FieldErrors, FieldError } from "react-hook-form";

export function findInputError(errors: FieldErrors, name: string) {
  const filtered: { error?: FieldError } = Object.keys(errors)
    .filter((key) => key.includes(name))
    .reduce((cur, key) => {
      return Object.assign(cur, { error: errors[key] });
    }, {});
  return filtered;
}
